/** Labels and colours shared by the Cora page's tabs, kept in one place so they always agree. */
import type { CriterionStatus, Outcome, Recommendation, RunStatus } from '../../services/coraApi';

export const RECOMMENDATIONS: Recommendation[] = [
  'SHORTLIST RECOMMENDATION',
  'CONSIDER WITH CLARIFICATIONS',
  'MISSING MUST HAVES',
];

export const RECOMMENDATION_LABEL: Record<Recommendation, string> = {
  'SHORTLIST RECOMMENDATION': 'Shortlist',
  'CONSIDER WITH CLARIFICATIONS': 'Consider',
  'MISSING MUST HAVES': 'Missing must-haves',
};

export const RECOMMENDATION_CLASS: Record<Recommendation, string> = {
  'SHORTLIST RECOMMENDATION': 'bg-green/10 text-green border-green',
  'CONSIDER WITH CLARIFICATIONS': 'bg-orange/10 text-orange border-orange',
  'MISSING MUST HAVES': 'bg-red/10 text-red border-red',
};

export const STATUS_LABEL: Record<RunStatus, string> = {
  running: 'Screening…',
  screened: 'Screened',
  no_resume: 'No readable CV',
  failed: 'Failed',
  write_failed: 'Needs attention',
};

export const OUTCOME_LABEL: Record<Outcome, string> = {
  advanced: 'Moved forward',
  archived: 'Archived',
  pending: 'Still new',
  unknown: '—',
};

export const CRITERION_EMOJI: Record<CriterionStatus, string> = { met: '✅', missing: '❌', unsure: '❓' };

export const ISSUE_LABEL: Record<string, string> = {
  'invalid-posting-id': 'Lever posting ID is malformed',
  'invalid-scoring-document': 'Scoring document link is not a Google Doc',
  'duplicate-posting': 'Shares a Lever posting with another position',
  'posting-not-found': 'Lever has no posting with this ID — check the ID in Airtable',
  'scoring-document': 'Scoring document could not be read',
  lever: 'Lever could not be reached',
};

export const leverUrl = (opportunityId: string) => `https://hire.lever.co/candidates/${opportunityId}`;

/** "12 Oct, 17:56" in Berlin time, or a dash. */
export function fmtWhen(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleString('en-GB', { timeZone: 'Europe/Berlin', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export const fmtPct = (value: number | null) => (value === null ? '—' : `${value}%`);
export const fmtSeconds = (ms: number | null | undefined) => (ms ? `${Math.round(ms / 1000)} s` : '—');
export const fmtUsd = (usd: number) => `$${usd.toFixed(2)}`;

/** Lower-case match on name, position or recruiter — the three things a recruiter searches by. */
export function matchesQuery(row: { candidateName: string; positionTitle: string; recruiter: string }, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [row.candidateName, row.positionTitle, row.recruiter].some((v) => v.toLowerCase().includes(q));
}
